The product ID for the update.

The ad product selected will determine the features and performance of the job ad.
This is not the identifier of the job ad itself; see `UpdatePostedPositionProfile_PositionProfileInput.profileId` for that.

You cannot provide the same product ID that was initially used to post the job ad.
Display ad selection to the user in your update workflow by using the Ad Selection Panel or `advertisementProducts` query.
This will present a distinct set of update products along with associated pricing and payment information.
Once an update product has been selected, its ID can be passed in this field.

In certain scenarios, you may need to update a job ad without displaying ad selection to the hirer.
You can retain the existing ad product by omitting this field entirely.
